/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1EditIcon20Solid = forwardRef('People1EditIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.168 6.168a4.167 4.167 0 1 1-8.335 0 4.167 4.167 0 0 1 8.335 0Z" }),
        React.createElement("path", { d: "M13.999 12.501C12.578 12.059 11.068 12 10 12c-2.362 0-6.887.29-7.827 4.369C1.97 17.252 2.735 18 3.641 18H9.5v-.172a2 2 0 0 1 .586-1.414l3.913-3.913Z" }),
        React.createElement("path", { d: "M11 18.414V19.5a.5.5 0 0 0 .5.5h1.086a1 1 0 0 0 .707-.293l4.803-4.803-2-2-4.803 4.803a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m19.682 13.318-.878.879-2-2 .878-.879a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 1 0 1.414Z" })));
});
